<div>
  <ion-input [readonly]="true"
             mode="md"
             fill="outline"
             [(ngModel)]="selectedCountryText"
             id="select-country">
    @if (selectedCountry.value?.iso) {
      <ion-img style="width: 32px" slot="start" alt="Satel Realty Riyadh" [src]="'assets/flags_iso/png/'+ selectedCountry.value.iso.toLowerCase() +'.png'"></ion-img>
    } @else {
      <ion-spinner slot="start" name="dots"></ion-spinner>
      <ion-spinner slot="start" name="dots"></ion-spinner>
    }
  </ion-input>
  <!-- SELECT COUNTRY -->
  <ion-modal trigger="select-country"
             [keepContentsMounted]="true"
             class="ion-card-modal-90">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
              <ion-icon name="arrow-back"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title>Pick a country</ion-title>
        </ion-toolbar>
        <ion-searchbar [(ngModel)]="filterCountryText"></ion-searchbar>
      </ion-header>
      <ion-content>
        <ion-list lines="none">
          @for (x of countryListDb | countryFilter: filterCountryText; track x.id) {
            <ion-item class="country-item" (click)="pickCountry(x)">
              <ion-img style="width: 32px" slot="start" [src]="'./assets/flags_iso/png/'+ x.iso.toLowerCase() +'.png'"></ion-img> {{x.name}}
<!--              <ion-text color="primary"><small>{{x.iso}}</small></ion-text>-->
              <small slot="end">+{{x.phonecode}}</small>
            </ion-item>
          }
        </ion-list>
      </ion-content>
    </ng-template>
  </ion-modal>
  <!--                SELECT COUNTRY MODAL END -->

</div>
